import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/aromatics/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/aromatics/industry/petroleumList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/aromatics/industry/getPetroleumInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function oilBenzeneReportNoAuthList(query) {
    return request({
        url: '/aromatics/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/aromatics/report/reportCaprolactamList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/aromatics/report/technicalAdipicAcidList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function oilBenzeneReportDetail(id) {
    return request({
        url: `/aromatics/report/boardAdipicAcidInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/aromatics/report/technicalAdipicAcidInfo/${id}`,
        method: 'get',
    })
}


// 产量列表（无权限）
export function yieldNoAuthList(query) {
    return request({
        url: '/aromatics/yield/noAuth/list',
        method: 'get',
        params: query
    })
}

// 产量列表
export function yieldList(query) {
    return request({
        url: '/aromatics/druidEnter/petroleumYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getPetroleumYieldInfo`,
        method: 'get',
        params: query
    })
}

// 相关产品列表（无权限）其他
export function productPricedNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/price/noAuth/petroleumPlaceList',
        method: 'get',
        params: query
    })
}

// 相关产品列表其他
export function productPricedList(query) {
    return request({
        url: '/aromatics/metatron/price/petroleumPlaceList',
        method: 'get',
        params: query
    })
}

// 相关产品详情其他
export function productPriceDetail(query) {
    return request({
        url: `/aromatics/metatron/price/detailsPetroleumPlace`,
        method: 'get',
        params: query
    })
}

// 相关产品列表苯乙烯
export function productPricedListBen(query) {
    return request({
        url: '/aromatics/industry/styreneList',
        method: 'get',
        params: query
    })
}

// 相关产品详情苯乙烯
export function productPriceDetailBen(id) {
    return request({
        url: `/aromatics/industry/getStyreneInfo/${id}`,
        method: 'get',
    })
}

// 价格列表（无权限）
export function oilBenzenePriceNoAuthList(query) {
    return request({
        url: '/aromatics/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/aromatics/druidEnter/petroleumListPrice',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getPetroleumListPriceInfo`,
        method: 'get',
        params: query
    })
}

// 进出口列表(国销)
export function exitGuoList(query) {
    return request({
        url: '/aromatics/industry/saleStatisticsList',
        method: 'get',
        params: query
    })
}

// 进出口详情(国销)
export function exitGuoDetail(id) {
    return request({
        url: `/aromatics/industry/getSaleStatisticsInfo/${id}`,
        method: 'get',
    })
}

// 进出口列表(数据统计)
export function exitShuList(query) {
    return request({
        url: '/aromatics/industry/dataStatisticsList',
        method: 'get',
        params: query
    })
}

// 进出口详情(数据统计)
export function exitShuDetail(id) {
    return request({
        url: `/aromatics/industry/getDataStatisticsInfo/${id}`,
        method: 'get',
    })
}

// 装置动态列表
export function deviceList(query) {
    return request({
        url: '/aromatics/industry/deviceDynamicList',
        method: 'get',
        params: query
    })
}

// 装置动态详情
export function deviceDetail(id) {
    return request({
        url: `/aromatics/industry/getDeviceDynamicInfo/${id}`,
        method: 'get',
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/aromatics/industry/portStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(id) {
    return request({
        url: `/aromatics/industry/getPortStockInfo/${id}`,
        method: 'get',
    })
}

// 后两个价格列表
export function backPriceList(query) {
    return request({
        url: '/aromatics/industry/internationalPriceList',
        method: 'get',
        params: query
    })
}

// 后两个价格详情
export function backPriceDetail(id) {
    return request({
        url: `/aromatics/industry/getInternationalPriceInfo/${id}`,
        method: 'get',
    })
}

// 价格详情折线图
export function priceLineDetailData(query) {
    return request({
        url: '/aromatics/price/lineChart',
        method: 'get',
        params: query
    })
}

// 库存详情折线图
export function stockDetailData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}

// 价格详情三年折线图
export function priceDetailData() {
    return request({
        url: '/aromatics/metatron/detail/petroleumPriceLineChart',
        method: 'get',
    })
}

// 进出口详情柱状图
export function exitDetailData(query) {
    return request({
        url: '/aromatics/metatron/detail/exitDataTotalHistogram',
        method: 'get',
        params: query
    })
}

// 价格首页折线图
export function priceLineData(query) {
    return request({
        url: '/aromatics/metatron/detail/noAuth/serviceLineChart',
        method: 'get',
        params: query
    })
}

// 价格首页折线图大图
export function priceLineDataBig(query) {
    return request({
        url: '/aromatics/metatron/detail/petroleumPriceLineChart',
        method: 'get',
        params: query
    })
}

// 开工率首页折线图
export function rateLineData(query) {
    return request({
        url: '/aromatics/rate/noAuth/lineChart',
        method: 'get',
        params: query
    })
}

// 开工率折线图大图
export function rateLineDataBig(query) {
    return request({
        url: '/aromatics/metatron/detail/openRateLineChart',
        method: 'get',
        params: query
    })
}

// 华东市场价格详情折线图
export function priceDetailDataHua(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChartOneYear',
        method: 'get',
        params: query
    })
}

// 产业链
export function chainList(query) {
    return request({
        url: '/aromatics/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 化工产品外链权限
export function getAuthFlag() {
    return request({
        url: '/aromatics/metatron/detail/getAuthFlag',
        method: 'get',
    })
}

// 化工产品外链权限
export function getAuthFlagHua() {
    return request({
        url: '/aromatics/metatron/especially/petroleumReportForm',
        method: 'get',
    })
}


// 化工监控详情表权限
export function authChemicalDetail() {
    return request({
        url: '/aromatics/metatron/especially/chemicalDetailForm',
        method: 'get',
    })
}
//  化工监控汇总表权限
export function authChemicalSummary() {
    return request({
        url: '/aromatics/metatron/especially/chemicalSummaryForm',
        method: 'get',
    })
}
//  化工产品价格日报
export function authChemicalDay() {
    return request({
        url: '/aromatics/metatron/especially/chemicalDayForm',
        method: 'get',
    })
}


// 企业资讯列表(首页无权限)
export function oilBenzeneExamineNoAuthList(query) {
    return request({
        url: '/aromatics/document/dataFormChemicalBranchNew/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 企业资讯列表
export function examineList(query) {
    return request({
        url: '/aromatics/document/dataFormChemicalBranchNew/queryPage',
        method: 'get',
        params: query
    })
}

// 企业资讯详情
export function examineDetail(query) {
    return request({
        url: '/aromatics/document/dataFormChemicalBranchNew/queryList',
        method: 'get',
        params: query
    })
}
